export function jsonTryParse(text, getValue = false) {
  try {
    return JSON.parse(text)
  } catch (err) {
    if (!getValue) return null
    return text
  }
}
